<template>
  <div id="externalChangelog">
    
    <div class="vo-external-card has-version">
      <vo-external-header :title="title" :version="version"></vo-external-header>

      <div class="vo-body">

        <div class="vo-title">{{ title }}</div>

        <div class="patch-title">2.1.0 <span class="date">July 3, 2018</span></div>
        <div class="patch-info">
          <ul>
            <li>
              <div class="name">Knowledge Base</div>
              <div class="value">Need help using Vilio? Take a look at our new Knowledge Base: <a target="_blank" :href="urls.knowledgeBase">{{ urls.knowledgeBase }}</a> </div>
            </li>
            <li>
              <div class="name">Unit Roles</div>
              <div class="value">Invites can now be created directly on a unit. Existing users can also now be added directly to a unit.</div>
            </li>
            <li>
              <div class="name">Searching</div>
              <div class="value">People, Invites, and Units are now searchable.</div>
            </li>
            <li>
              <div class="name">Bug Fixes</div>
              <div class="value">Minor bug fixes.</div>
            </li>
          </ul>
        </div>

        <div class="patch-title">2.0.1 <span class="date">April 6, 2018</span></div>
        <div class="patch-info">
          <div class="section-title">Updates</div>
          <ul>
            <li>
              <div class="name">Mobile Applications</div>
              <div class="value">Vilio 2.0.1 is now available on the Android and iOS app stores.</div>
            </li>
            <li>
              <div class="name">Browser Support</div>
              <div class="value">Added support for Internet Explorer 11.</div>
            </li>
            <li>
              <div class="name">Bug Fixes</div>
              <div class="value">Minor bug fixes.</div>
            </li>
          </ul>
        </div>

        <div class="patch-title">2.0.0 <span class="date">March 21, 2018</span></div>
        <div class="patch-info">
          
          <div class="section-title">Vilio 2.0</div>
          <ul>
            <li>
              <div class="name">Rebuilt from the Ground Up</div>
              <div class="value">Vilio has been rebuilt using newer technologies, improving the speed and quality of the application.</div>
            </li>
            <li>
              <div class="name">New UI Components</div>
              <div class="value">All buttons, forms, and other interactable items have a refreshing new look.</div>
            </li>
            <li>
              <div class="name">Android and iOS App Updates Coming Soon</div>
            </li>
            <li>
              <div class="value">Please report any issues you experience using our <a :href="urls.feedback" target="_blank">Feedback system</a></div>
            </li>
          </ul>

          <div class="section-title">New Features</div>
          <ul>
        
            <li>
              <div class="name">Ticket Tag Updates</div>
              <div class="value">Ticket Managers can now update Ticket Tags on existing tickets.</div>
            </li>
            
          </ul>
          
          <div class="section-title">Updates</div>
          <ul>
                            
            <li>
              <div class="value">Bug Fixes</div>
            </li>

          </ul>
        </div>

        <!-- 1.2.9 -->
        <div class="patch-title">1.2.9 <span class="date">November 16, 2017</span></div>
        <div class="patch-info">

          <div class="section-title">New Features</div>
          <ul>
        
            <li>
              <div class="name">Daily Open Work Order Summary</div>
              <div class="value">Users assigned to tickets will now receive daily email summaries of their open work orders.</div>
            </li>

            <li>
              <div class="name">Changelog Prompt</div>
              <div class="value">When viewing a new version for the first time, a summarized changelog will appear. This feature can be disabled from inside the changelog prompt.</div>
            </li>
            
          </ul>
          
          <div class="section-title">Updates</div>
          <ul>

            <li>
              <div class="name">Add Ticket Photos</div>
              <div class="value">Tickets can now have up to 15 photos, which can be added after tickets have been created.</div>
            </li>          
            
            <li>
              <div class="name">Ticket Tags</div>
              <div class="value">Multiple ticket tags can now be selected when creating a new ticket.</div>
            </li>

            <li>
              <div class="name">Notification Settings</div>
              <div class="value">Added more notification settings for management roles.</div>
            </li>
                      
            <li>
              <div class="name">Emergency Prompt</div>
              <div class="value">When creating a ticket, users are now prompted to contact building management directly during an emergency.</div>
            </li>
            
            <div class="section-title">Bugs &amp; Fixes</div>        
            <li>
              <div class="bug">
                Fixed a bug preventing users from being assigned to tickets depending on the ticket's status.
              </div>
            </li>
            
            <li>
              <div class="bug">
                Fixed a bug preventing ticket chat from displaying system messages immediately.
              </div>
            </li>
            
            <li>
              <div class="bug">
                Fixed a bug preventing push notifications for Ticket Note updates.
              </div>
            </li>

            <li>
              <div class="bug">
                Added an option for Ticket Note email notifications.
              </div>
            </li>
            
            <li>
              <div class="bug">
                Fixed a bug causing email addresses to be case sensitive.
              </div>
            </li>
            
          </ul>

        </div>


        <!-- 1.2.5 -->
        <div class="patch-title">1.2.5 <span class="date">March 31, 2017</span></div>
        <div class="patch-info">
        
          <div class="section-title">Updates</div>
          <ul>
            <li>
              <div class="name">Role Updates</div>
              <div class="value">Added invite permission to property specific roles, allowing them to view and create invites for unit based roles in that property.</div>
            </li>
          </ul>
        </div>

        <!-- 1.2.3 -->
        <div class="patch-title">1.2.3 <span class="date">January 12, 2017</span></div>
        <div class="patch-info">
          <ul>
            <li>
              <div class="bug">
                Fixed bug causing Push Notifications to fail to send for mobile devices.
              </div>
            </li>
          </ul>
        </div>


        <!-- 1.2.2 -->
        <div class="patch-title">1.2.2 <span class="date">September 28, 2016</span></div>
        <div class="patch-info">
          
          <div class="section-title">New Features</div>
          <ul>
            <li>
              <div class="name">Ticket Photos</div>
              <div class="value">As requested via our user feedback page, you can now choose and upload up to 5 photos when creating a ticket.</div>
            </li>
            <li>
              <div class="name">Notification Scheduler</div>
              <div class="value">Schedule which days and times you'd like to receive email or push notifications from Vilio. All updates will still appear in your Recent Activity (detailed below).</div>
            </li>
          </ul>

          <div class="section-title">Updates</div>
          <ul>
            <li>
              <div class="name">Recent Activity</div>
              <div class="value">The Notification section has been renamed to Recent Activity.  Email and Push notification updates will continue to appear in your Recent Activity, however Web Notification options have been removed to ensure that all updates are properly documented.</div>
            </li>
            <li>
              <div class="name">Improved Search Bar</div>
              <div class="value">Added more visual indications and clearing options when searching, specifically helpful for mobile users.</div>
            </li>
            <li>
              <div class="name">Design Refresh</div>
              <div class="value">Made tweaks to visuals across all pages of the application, including more visual feedback when waiting for actions to finish (creating tickets, saving profile changes, etc.)</div>
            </li>
            <li>
              <div class="name">Resend Invite</div>
              <div class="value">Resend invites by opening the invite on the People screen and clicking "Resend".</div>
            </li>
            <li>
              <div class="name">Ticket Creation</div>
              <div class="value">After creating a new ticket, you will now be redirected to the new ticket.</div>
            </li>
            <li>
              <div class="name">Reactive Ticket List</div>
              <div class="value">Ticket filters and sorts are now persistantly applied to the Ticket List. When tickets are updated to meet the current Ticket Filters, they will be added to the Ticket List, and placed in a position that applies to the current sorting option selected. When tickets are updated and no longer meet the current filter, they are removed from the Ticket List. When sorting by Activity, tickets will be repositioned according to the current Activity sort selected.</div>
            </li>
            <li>
              <div class="name">List Sorting</div>
              <div class="value">List sorting options will now be saved and applied when reloading the application.</div>
            </li>
            <li>
              <div class="name">Linked Items</div>
              <div class="value">Added links between pages where permitted. Any time a user's name, a unit name, or a property name appears in green text, the text is linked to that item's page.</div>
            </li>
          </ul>

          <div class="section-title">Bugs &amp; Fixes</div>
          <ul>
            <li>
              <div class="bug">
                Fixed a bug which caused an extra, invalid Ticket Tag to appear as an option when creating a new ticket.
              </div>
              <div class="bug">
                Fixed a bug which allowed users to attempt to load Invites when refreshing after an invite is deleted.
              </div>
              <div class="bug">
                Fixed a bug which caused information to appear to be missing from Invites when they are created.
              </div>
              <div class="bug">
                Fixed a bug which caused certain properties to fail to load when accessing them from the Properties page with certain permission levels.
              </div>
              <div class="bug">
                Fixed a bug which caused inconsistencies when changing filters, sometimes closing the filter drawer and others leaving it open. Now, all filter changes will leave the drawer opened until it is closed by the user.
              </div>
              <div class="bug">
                Fixed a bug which caused the Invite modal to fail on Edge and Internet Explorer.
              </div>
            </li>
          </ul>
        </div>

        <!-- 1.1.6 -->
        <div class="patch-title">1.1.6 <span class="date">August 15, 2016</span></div>
        <div class="patch-info">
          <ul>
            <li>
              <div class="bug">
                Minor bug fixes.
              </div>
            </li>
          </ul>
        </div>

        <!-- 1.1.4 -->
        <div class="patch-title">1.1.4 <span class="date">August 12, 2016</span></div>
        <div class="patch-info">
          <div class="section-title">New Features</div>
          <ul>
            <li>
              <div class="name">Disconnected Toast</div>
              <div class="value">Added message toast when disconnected from the Internet. The page will refresh when reconnected to ensure the applicaiton is properly synced with the server.</div>
            </li>
          </ul>

          <div class="section-title">Updates</div>
          <ul>
            <li>
              <div class="name">Custom Statuses</div>
              <div class="value">Added support for custom statuses. Creating and editing custom statuses will be added in a future update.</div>
            </li>
            <li>
              <div class="name">Updated Inputs</div>
              <div class="value">Updated input fields across the application, which now provide more context when data is entered. Labels will float above the input indicating what the field is used for.</div>
            </li>
          </ul>

          <div class="section-title">Bugs &amp; Fixes</div>
          <ul>
            <li>
              <div class="bug">
                Fixed a bug which caused ticket tags to occasionally fail to load on the Create Ticket dialog.
              </div>
            </li>
          </ul>
        </div>

        <!-- 1.1.3 -->
        <div class="patch-title">1.1.3 <span class="date">July 28, 2016</span></div>
        <div class="patch-info">
          <div class="section-title">New Features</div>
          <ul>
            <li>
              <div class="name">Search: Tickets</div>
              <div class="value">Added search support for Tickets.</div>
            </li>
            <li>
              <div class="name">Profile Colour</div>
              <div class="value">Choose a colour to personalize your profile. Your profile colour appears in your avatar.</div>
            </li>
          </ul>

          <div class="section-title">Updates</div>
          <ul>
            <li>
              <div class="name">Ticket Sort: Activity</div>
              <div class="value">Added ticket sorting by recent activity. Tickets will be displayed in the order of most recent status updates, assignee updates, notes, and ticket comments.</div>
            </li>
            <li>
              <div class="name">Invites</div>
              <div class="value">Added Role information when viewing Invites.</div>
            </li>
            <li>
              <div class="name">Login Redirect</div>
              <div class="value">When attempting to open a page while not signed in (ie: clicking an Email Notification), you will now be prompted to sign in to continue. After signing in, you will be taken directly to the original intended destination within the app.</div>
            </li>
          </ul>
          
          <div class="section-title">Bugs &amp; Fixes</div>
          <ul>
            <li>
              <div class="bug">
                Fixed a bug that caused lists to remove items from the top of the list when scrolling down.
              </div>
              <div class="bug">
                Fixed a bug that allowed users to enter the application with no account after signing out, which would show empty data as no user was actually signed in.
              </div>
            </li>
          </ul>
        </div>

        <!-- 1.1.2 -->
        <div class="patch-title">1.1.2 <span class="date">July 26, 2016</span></div>
        <div class="patch-info">
          <div class="section-title">New Features</div>
          <ul>
            <li>
                <div class="name">Search</div>
                <div class="value">Added search support for People, Invites, and Units. Ticket search coming soon. (Added in 1.1.3)</div>
              </li>
            <li>
              <div class="name">In App Browser</div>
              <div class="value">Links to external pages such as the Changelog and Support now open as an overlay, making them easier to access and dismiss from within the mobile applications.</div>
            </li>
          </ul>
          
          <div class="section-title">Bugs &amp; Fixes</div>
          <ul>
            <li>
              <div class="bug">
                Fixed a bug causing a crash when opening external pages inside the mobile applications.
              </div>
            </li>
          </ul>
        </div>

        <!-- 1.1.0 -->
        <div class="patch-title">1.1.0 <span class="date">July 25, 2016</span></div>
        <div class="patch-info">
          <div class="section-title">New Features</div>
          <ul>
            <li>
              <div class="name">Changelog</div>
              <div class="value">View a list of our recent updates, new features, bug fixes, and more.</div>
            </li>
  <!--           <li>
              <div class="name">Swipe Gestures</div>
              <div class="value">Use swipe gestures to open menus, select items on list, and other quick ways of maneuvering through Vilio.</div>
            </li> -->
            <li>
              <div class="name">Feedback System</div>
              <div class="value">Want to help shape the future of Vilio? Report bugs, give suggestions, or rate your experience using our feedback system. We greatly appreciate any feedback you'd like to provide.</div>
            </li>
            <li>
              <div class="name">Universal Links</div>
              <div class="value">Added support for universal links, which allows email notifications and other links to be opened straight to your Vilio Android or iPhone app.</div>
            </li>
          </ul>

          <div class="section-title">Updates</div>
          <ul>
            <li>
              <div class="name">Ticket Filter - Unresolved Status</div>
              <div class="value">
                Under Ticket Statuses, the option "All" has been changed to "Unresolved". 
              </div>
              <div class="value">
                Filtering by Unresolved will show all tickets that have not been resolved. To view Resolved tickets, simply filter by Resolved.</div>
            </li>
            <li>
              <div class="name">Mobile App Prompt</div>
              <div class="value">
                Added prompt for mobile web users to detect if they are using a device for which an official Vilio app is available, which then provides an option and link to download from the respective app stores.
              </div>
            </li>
            <li>
              <div class="name">New External Pages</div>
              <div class="value">
                Implemented the following newly designed external pages: Account Setup, Password Reset, Email Changed, Changelog, Support, Privacy Policy &amp; Terms of Use, and 404.
              </div>
            </li>
          </ul>

          <div class="section-title">Bugs &amp; Fixes</div>
          <ul>
            <li>
              <div class="bug">
                Fixed a bug causing old items to be displayed on screens when navigating from the Properties screen.
              </div>
              <div class="bug">
                Fixed a bug causing postal code input requiring the user type capital letters to pass validation.
              </div>
              <div class="bug">
                Fixed a bug which caused incorrect icons to be displayed for the favicon, homescreen icons, and Android system tray notification.
              </div>
              <div class="bug">
                Removed unnecessary notification options for role-dependent notifications unless the user posesses those roles.
              </div>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>
</template>


<script>

  export default {
    data () {
      return {
        title: 'Vilio Changelog'
      }
    },

    computed: {

      version () {
        return VERSION;
      },

      urls () {
        return EXTERNAL_URLS
      }

    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #externalChangelog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    @include scrollable;

    .vo-title {
      margin-bottom: 0;
    }

    a {
      color: $primary;
    }

    .release-title {
      font-size: 24px;
      color: $black87;
      border-bottom: 2px solid $black54;
      width: 100%;
      margin-bottom: 24px;
      line-height: 40px;
    }
  
    .patch-title {
      font-size: 20px;
      color: rgba(0,0,0,.87);
      border-bottom: $borderBlack12;
      width: 100%;
      margin-bottom: 24px;
      line-height: 35px;
      margin-top: 40px;

      &:first-of-type {
        margin-top: 0;
      }
    }

    .latest-changes {
      color: $black24;
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .date {
      font-size: 16px;
      margin-left: 8px;
    }

    .section-title {
      @include fontPrimary500();
      
      color: $black54;
      font-size: 16px;
      margin: 24px 0 16px;
    }
    
    .patch-info {
      font-size: 16px;
      color: rgba(0,0,0,1);
      padding: 0 16px;
    
      .name {
        color: $black87;
        margin: 8px 0 8px;
        display: list-item;
        list-style-type: disc;
      }

      .value {
        display: list-item;
        margin-left: 16px;
        font-size: 14px;
        list-style-type: circle;
        line-height: 24px;
        color: $black54;
      }

      .bug {
        color: $black54;
        display: list-item;
        font-size: 14px;
        list-style-type: disc;
        margin-bottom: 8px;
      }
    
      ul {
        margin-left: 24px;
        list-style-type: none;
      }
    }
  }

  @media screen and (max-width: 780px) {
  
    #externalChangelog {
    
      background: $lightGreen !important;
    
      .vo-title {
        display: none;
      }
    
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ExternalChangelog.vue